document.addEventListener("DOMContentLoaded", function () {
  GLightbox({
    selector: ".glightbox",
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Dawn desktop breakpoint
  const isDesktop = window.matchMedia("(min-width: 990px)");

  if (!isDesktop.matches) return; // Exit if not desktop

  const header = document.querySelector("sticky-header"); // optional if unused
  const megamenu = document.querySelector("#megamenu");

  if (!megamenu) return;

  let lastScrollY = window.scrollY;

  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      megamenu.classList.add("hidden");
    }

    lastScrollY = currentScrollY;
  });

});


  function isCartMutationUrl(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || '');
  }

  function extractCartTotal(payload) {
    if (!payload || typeof payload !== 'object') return null;

    if (typeof payload.total_price === 'number') {
      return payload.total_price / 100;
    }

    if (payload.cart && typeof payload.cart.total_price === 'number') {
      return payload.cart.total_price / 100;
    }

    return null;
  }

  function dispatchCartUpdated(payload) {
    const cartTotal = extractCartTotal(payload);

    if (typeof cartTotal === 'number') {
      window.dispatchEvent(new CustomEvent('mm:cart-updated', {
        detail: { cartTotal }
      }));
      return;
    }

    window.dispatchEvent(new Event('mm:cart-updated'));
  }

  let cartSnapshotRequest = null;

  function fetchCartSnapshot() {
    if (!cartSnapshotRequest) {
      cartSnapshotRequest = fetch('/cart.js')
        .then((res) => res.json())
        .finally(() => {
          cartSnapshotRequest = null;
        });
    }

    return cartSnapshotRequest;
  }

  function installCartMutationListeners() {
    if (window.__mmProgressCartHooksInstalled) return;
    window.__mmProgressCartHooksInstalled = true;

    if (typeof window.fetch === 'function') {
      const originalFetch = window.fetch;
      window.fetch = function (input, init) {
        const requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
        const isCartMutation = isCartMutationUrl(requestUrl);

        return originalFetch.call(this, input, init).then((response) => {
          if (isCartMutation) {
            const contentType = response.headers.get('content-type') || '';

            if (contentType.includes('application/json')) {
              response.clone().json()
                .then((payload) => {
                  dispatchCartUpdated(payload);
                })
                .catch(() => {
                  dispatchCartUpdated();
                });
            } else {
              dispatchCartUpdated();
            }
          }
          return response;
        });
      };
    }

    if (window.XMLHttpRequest && !window.XMLHttpRequest.__mmProgressPatched) {
      const xhrOpen = window.XMLHttpRequest.prototype.open;
      const xhrSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__mmProgressIsCartMutation = typeof url === 'string' && isCartMutationUrl(url);
        return xhrOpen.apply(this, arguments);
      };

      window.XMLHttpRequest.prototype.send = function () {
        if (this.__mmProgressIsCartMutation) {
          this.addEventListener('loadend', () => {
            let payload;

            try {
              if (this.responseType === 'json') {
                payload = this.response;
              } else if (!this.responseType || this.responseType === 'text') {
                payload = this.responseText ? JSON.parse(this.responseText) : undefined;
              }
            } catch (error) {
              payload = undefined;
            }

            dispatchCartUpdated(payload);
          });
        }
        return xhrSend.apply(this, arguments);
      };

      window.XMLHttpRequest.__mmProgressPatched = true;
    }
  }

  class MetroManilaProgress extends HTMLElement {
    constructor() {
      super();
      this.threshold = 5000;
      this.pendingSubmitRefresh = null;
      this.handleCartUpdate = this.handleCartUpdateEvent.bind(this);
      this.handlePotentialCartSubmit = this.handleProductFormSubmit.bind(this);
    }

    connectedCallback() {
      this.render();
      this.bindCartEvents();
      this.style.display = 'block';
      this.fetchCartTotal();
    }

    render() {
      this.style.display = 'none';

      this.innerHTML = `
      <div class="mm-progress-bar">
        <p class="mm-progress-text">
        🚚 You’re <strong class="mm-remaining">₱5,000</strong> away from <strong>FREE Metro Manila shipping</strong>
        </p>
        <div class="mm-progress-track">
          <div class="mm-progress-fill" style="display: block;"></div>
        </div>
      </div>
    `;

      this.remainingEl = this.querySelector('.mm-remaining');
      this.textEl = this.querySelector('.mm-progress-text');
      this.fillEl = this.querySelector('.mm-progress-fill');
    }

    formatPeso(amount) {
      return `₱${amount.toLocaleString()}`;
    }

    updateProgress(cartTotal) {
      const remaining = Math.max(this.threshold - cartTotal, 0);
      const progress = Math.min((cartTotal / this.threshold) * 100, 100);

      this.fillEl.style.width = `${progress}%`;

      if (remaining > 0) {
        this.textEl.innerHTML = `🚚 You’re <strong class="mm-remaining">${this.formatPeso(remaining)}</strong> away from <strong>FREE Metro Manila shipping</strong>`;
        this.remainingEl = this.querySelector('.mm-remaining');
      } else {
        this.textEl.innerHTML = `🎉 Congratulations! You’ve unlocked <strong>FREE Metro Manila shipping!</strong>`;
      }

      const bar = this.querySelector('.mm-progress-bar');

        if (remaining <= 0) {
          bar.classList.add('is-complete');
        } else {
          bar.classList.remove('is-complete');
        }

    }

    fetchCartTotal() {
      fetchCartSnapshot()
        .then((cart) => {
          this.updateProgress(cart.total_price / 100);
        })
        .catch(() => {
          // Ignore temporary cart fetch failures to avoid breaking page scripts.
        });
    }

    handleCartUpdateEvent(event) {
      if (this.pendingSubmitRefresh) {
        window.clearTimeout(this.pendingSubmitRefresh);
        this.pendingSubmitRefresh = null;
      }

      const cartTotal =
        event &&
        event.detail &&
        typeof event.detail.cartTotal === 'number'
          ? event.detail.cartTotal
          : event &&
            event.detail &&
            event.detail.cart &&
            typeof event.detail.cart.total_price === 'number'
            ? event.detail.cart.total_price / 100
            : null;

      if (typeof cartTotal === 'number') {
        this.updateProgress(cartTotal);
        return;
      }

      this.fetchCartTotal();
    }


    bindCartEvents() {
      installCartMutationListeners();

      document.addEventListener('cart:refresh', this.handleCartUpdate);
      document.addEventListener('cart:change', this.handleCartUpdate);
      window.addEventListener('mm:cart-updated', this.handleCartUpdate);
      document.addEventListener('submit', this.handlePotentialCartSubmit, true);
    }

    disconnectedCallback() {
      if (this.pendingSubmitRefresh) {
        window.clearTimeout(this.pendingSubmitRefresh);
        this.pendingSubmitRefresh = null;
      }

      document.removeEventListener('cart:refresh', this.handleCartUpdate);
      document.removeEventListener('cart:change', this.handleCartUpdate);
      window.removeEventListener('mm:cart-updated', this.handleCartUpdate);
      document.removeEventListener('submit', this.handlePotentialCartSubmit, true);
    }

    handleProductFormSubmit(event) {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (form.closest('cart-drawer')) return;

      const action = form.getAttribute('action') || '';
      if (!/\/cart\/add(\.js)?(\?|$)/.test(action)) return;

      if (this.pendingSubmitRefresh) {
        window.clearTimeout(this.pendingSubmitRefresh);
      }

      this.pendingSubmitRefresh = window.setTimeout(() => {
        this.pendingSubmitRefresh = null;
        this.fetchCartTotal();
      }, 250);
    }
  }

  function mountProgressBarOnProductPage() {
    if (!document.body.classList.contains('template-product')) return;

    const hasProductPageBar = Array.from(document.querySelectorAll('metro-manila-progress'))
      .some((element) => !element.closest('cart-drawer'));
    if (hasProductPageBar) return;

    const productInfo = document.querySelector('.product__info-container');
    const productForm = productInfo
      ? productInfo.querySelector('form[action*="/cart/add"]')
      : document.querySelector('main form[action*="/cart/add"]');

    if (!productForm || !productForm.parentNode) return;

    const progressEl = document.createElement('metro-manila-progress');
    const formContainer = productForm.closest('.product-form') || productForm;
    formContainer.parentNode.insertBefore(progressEl, formContainer);
  }

  if (!customElements.get('metro-manila-progress')) {
    customElements.define('metro-manila-progress', MetroManilaProgress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountProgressBarOnProductPage);
  } else {
    mountProgressBarOnProductPage();
  }

  document.addEventListener('shopify:section:load', mountProgressBarOnProductPage);